// setTimeout(()=>{
//   const ajaxCart = document.querySelector('cart-form');
//   if(ajaxCart){
//       let observer = new MutationObserver(function (mutations) {
//           mutations.forEach(function (m) {
//             setTimeout(()=>{
//               BSS_B2B.cart.fixer(JSON.parse($('#bss-b2b-store-data').html()), true, true)
//               console.log(123)
//             },1500)
//           });
//       });
//       observer.observe(ajaxCart, { attributes: true, childList: true });
//   }
//   var passwordFieldElement = document.querySelector('.input-row.password-field');
//   var registrationFormElement = document.getElementById('bss-b2b-registration-form-render');
//   if (passwordFieldElement && registrationFormElement) {
//       passwordFieldElement.parentNode.insertBefore(registrationFormElement, passwordFieldElement.nextSibling);
//   }
// },1000)

// // Casey fix cartslider
// let counter = 0;
// let selector = "#rebuy-cart";
// const interval = setInterval(() => {
//     const element = document.querySelector(selector);
//     if (element) {
//         handleMutationShowCart();
//         clearInterval(interval);
//     } else {
//         counter += 100;
//         if (counter >= 10000) {
//             clearInterval(interval);
//         }
//     }
// }, 100);

// function handleMutationShowCart(){
//   const targetNode = document.getElementById('rebuy-cart');
//   const config = {
//     attributes: true,
//     attributeFilter: ['class'],
//   };
  
//   const observer = new MutationObserver((mutationsList, observer) => {
//     for (let mutation of mutationsList) {
//       if (mutation.type === 'attributes' && mutation.target.id === 'rebuy-cart') {
//         if (mutation.target.classList.contains('is-visible')) {
//           let buttonBSS = $(".rebuy-cart__checkout-button").clone()
//           $(".rebuy-cart__checkout-button").before(buttonBSS)
//           BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
//           $(".rebuy-cart__checkout-button+.rebuy-cart__checkout-button").hide();
//           handleCart();
//           handleProduct();
//         }
//       }
//     }
//   });
  
//   if (targetNode) {
//     observer.observe(targetNode, config);
//   }
// }

// window.addEventListener("cart_changed", (e) => {
//     handleCart();
//     handleProduct();
// });

// async function handleCart(){
//     const response = await fetch('/cart.js');
//     const data = await response.json();
//     $(".rebuy-cart__flyout-item").each((ind, item) => {
//         const title = $(item).find(".rebuy-cart__flyout-item-product-title").text()
//         const itemCart = data.items.find(item => item.product_title === title);
//         if(itemCart) {
//             const cartKey = itemCart.key;
//             const priceEle = $(item).find(".rebuy-cart__flyout-item-price");
//             if(priceEle) {
//                 priceEle.attr("bss-b2b-cart-item-key", cartKey)
//                 priceEle.attr("bss-b2b-item-original-price", '')
//             }
//         }
//     })
//     $(".rebuy-cart__flyout-subtotal-amount").attr("bss-b2b-cart-total-price", "")
//     BSS_B2B.cart.fixer(BSS_B2B.shopData,0,0)
//     BSS_B2B.handleCartCheckoutBtn(BSS_B2B.shopData)
// }

// function handleProduct(){
//     $(".rebuy-cart__flyout .rebuy-product-block").each((ind, item) => {
//         const productTitle = $(item).find(".rebuy-product-title").text();
//     fetch('/search/suggest.json?q=' + productTitle + '&resources[type]=product')
//       .then(response => response.json())
//       .then(data => {
//           const priceEle = $(item).find(".rebuy-product-price");
//         if (data?.resources
//     ?.results?.products?.length > 0) {
//           var productId = data.resources
//     .results.products[0].id;
//             priceEle.attr("bss-b2b-product-price", "")
//             priceEle.attr("bss-b2b-product-id", productId)
//         } else {
//            if(productTitle === 'Mid Blue Pencil Stretch Stripes Shirt -White Club Collar With Pin') {
//                 priceEle.closest(".rebuy-product-block").remove()
//                 console.log('No product found with title:', productTitle);
//             }
//         }
//       })
//       .catch(error => {
//         console.error('Error fetching product data:', error);
//       }).finally(() => {
//         BSS_B2B.cp.changeProductPrice(BSS_B2B.shopData,0,0);
//       });
//     })
// }

// end fix cart slider


// WEBSENSE BAR ORIGINAL 

// document.addEventListener("DOMContentLoaded", function () {
//   const announcementBar = document.getElementById("shopify-section-websensepro-announcement-bar");

//   if (announcementBar) {
//     // Add a class to make the section visible
//    // announcementBar.classList.add("visible");

//     // Alternatively, modify styles directly
//     announcementBar.style.visibility = "visible";
//     announcementBar.style.opacity = "1";
//     announcementBar.style.maxHeight = "100px"; // Adjust according to your content's height
//     announcementBar.style.overflow = "visible";
//   }
// });


// function showAnnouncementBar() {
//   const announcementBar = document.getElementById("shopify-section-websensepro-announcement-bar");
//   if (announcementBar) {
//     announcementBar.style.visibility = "visible";
//     announcementBar.style.opacity = "1";
//     announcementBar.style.maxHeight = "34px"; // exact height
//     announcementBar.style.overflow = "visible";
//   }
// }

// // Run immediately if element exists
// if (document.getElementById("shopify-section-websensepro-announcement-bar")) {
//   showAnnouncementBar();
// } else {
//   document.addEventListener("DOMContentLoaded", showAnnouncementBar);
// }



// Toggle buttton
document.addEventListener("DOMContentLoaded", function () {
    console.log("Custom filter toggle script loaded");

    document.addEventListener("click", function (event) {
        // Check if the clicked element has the 'data-toggle-filters' attribute
        let toggleButton = event.target.closest("[data-toggle-filters]");
        if (!toggleButton) return;

        console.log("Filter toggle clicked");

        // Get the filter container
        let filterContainer = document.querySelector(".filter-container");
        if (!filterContainer) {
            console.warn("Filter container not found!");
            return;
        }

        // Toggle filter visibility classes
        let isNowVisible = filterContainer.classList.toggle("filter-container--show-filters-desktop");
        filterContainer.classList.toggle("filter-container--show-filters-mobile", !isNowVisible);

        // Update the toggle button class
        document.querySelectorAll(".toggle-btn[data-toggle-filters]").forEach(function (btn) {
            btn.classList.toggle("toggle-btn--revealed-desktop", isNowVisible);
        });

        // Handle resized collection grid
        if (typeof theme !== "undefined" && theme.ProductBlockManager && theme.ProductBlockManager.afterImagesResized) {
            theme.ProductBlockManager.afterImagesResized();
        } else {
            console.warn("theme.ProductBlockManager.afterImagesResized() not found!");
        }

        // Reposition slick sliders if they exist
        document.querySelectorAll(".slick-slider").forEach(function (slider) {
            if ($(slider).hasClass("slick-initialized")) {
                $(slider).slick("setPosition");
            }
        });

        // Prevent default action (if it's inside a link or form)
        event.preventDefault();
    });
});





